import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import PropTypes from 'prop-types';
import React from 'react';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';

export default function ModuleProgressStepper({ activeStep, steps }) {
  return (
    <Stepper activeStep={activeStep} orientation="vertical">
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel>
            <CardText gutterBottom={false}>{label}</CardText>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}

ModuleProgressStepper.propTypes = {
  activeStep: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};
